/* eslint-disable */

import React from "react";

function Header() {
  return (
    <header className="header">
      <h1>IS YOUR BIRTHDAY PALINDROME?🎂🙃</h1>
    </header>
  );
}
export default Header;
